<template>
  <div id="not-found-flag">
    <svg id="NotFound"
         xmlns="http://www.w3.org/2000/svg"
         width="221"
         height="224.649"
         viewBox="0 0 221 224.649"
    >
      <path id="Path_288"
            data-name="Path 288"
            d="M53.176,224.649c.809-3.7,1.483-7.233,2.386-10.706a3.665,3.665,0,0,0-1.21-4.089Q28.313,184.832,2.375,159.7C1.663,159.009.963,158.3,0,157.35c3.826-3.189,7.486-6.38,11.3-9.356a5.922,5.922,0,0,0,2.56-5.307c-.141-11.3-.063-22.594-.063-33.891v-3.683h6.6c5.093,0,10.189.129,15.276-.054a6.585,6.585,0,0,1,5.874,2.457c1.144,1.388,2.556,2.541,4.344,4.279H39.362v15.931c.921-.583,1.714-1.04,2.463-1.568q46.051-32.533,92.061-65.13A6.869,6.869,0,0,0,136.34,57.4c4.477-18.014,8.823-36.064,13.206-54.1.872-3.582.881-3.581,5.073-3.017-.45,2.131-.9,4.243-1.431,6.774h67.668q.073.348.144.7c-1.094.5-2.185,1.012-3.289,1.5Q182.425,24.7,147.12,40.109a4.394,4.394,0,0,0-2.942,3.478c-1.122,5.239-2.4,10.445-3.794,15.613a4.29,4.29,0,0,0,1.056,4.479c1.818,2.014,3.475,4.184,5.09,6.153-2.36,4.379-5.381,3.708-8.9,1.173-.838,3.371-1.6,6.354-2.322,9.346q-15.9,65.714-31.826,131.42a5.485,5.485,0,0,0,.785,4.893c1.715,2.47,3.223,5.091,5.033,7.985ZM99.145,111.332c-12.543,12.85-24.827,25.434-37.2,38.111,12.407,19.686,24.88,39.477,37.755,59.906,10.658-44.1,21.137-87.461,31.616-130.822l-.423-.249q-14.459,17.414-28.987,34.907c-1.178-.789-2.206-1.481-2.763-1.853"
            transform="translate(0 0)"
            fill="#fff"
            fill-rule="evenodd"
      />
    </svg>
    <span>{{ getErrorMsg }}</span>
  </div>
</template>

<script>
export default {
  name: "NotFoundFlag",
  props:{
    msg: {
      type: String,
      required: false,
      default: 'content'
    }
  },
  computed: {
    getErrorMsg() {
      return `No ${this.msg.toUpperCase()} found. Please try again.`
    }
  }
}
</script>
<style scoped lang="scss">
@import "@/assets/sass/abstracts/_variables.scss";
div#not-found-flag {
  position: relative;
  display: flex;
  flex-direction: column;
  @include media-breakpoint-up(lg) {
    flex-direction: row;
    align-items: center;
  }
  span {
    @include font-14;
    padding: 10px 0;
    @include media-breakpoint-up(lg) {
      position: absolute;
      left:75%;
      width: 100%;
      white-space: nowrap;
    }
  }
}
</style>